/* eslint-disable no-restricted-globals */

const getCameraOrientation = () => {
    const { type } = screen.orientation

    return (type.startsWith('portrait')) ? 'portrait' : 'landscape'
}

export default getCameraOrientation
